import types from '../constants/types'
import config from '@/config'
// import cookies from 'js-cookie'
import { toQueryString } from '@/utils'
import axios from '@/http'

export const detailAction = {
  fetchDetail ({ dispatch, commit, state, rootState }, param, apiParam = config.apiParam) {
    const userToken = window.localStorage.getItem('token')
    const request = param.request || param.path
    commit(types.FETCH_DETAIL_REQUEST, { request: request })
    axios({
      method: 'post',
      url: '/' + param.path,
      transformRequest: [function (data, headers) {
        return toQueryString(data)
      }],
      data: Object.assign(
        {'token': userToken},
        param.data,
        apiParam)
    })
      .then((res) => {
        if (res && res.status === 200) {
          if (res.data.code !== '000000') {
            commit(types.FETCH_DETAIL_FAILURE, {
              request: request,
              data: res.data
            })
            if (typeof param.onFail === 'function') {
              param.onFail(res.data)
            }
          } else {
            commit(types.FETCH_DETAIL_SUCCESS, {
              request: request,
              data: res.data
            })
            if (typeof param.onSuccess === 'function') {
              param.onSuccess(res.data)
            }
          }
        }
      })
      .catch((error) => {
        commit(types.FETCH_DETAIL_FAILURE, {
          request: request,
          data: error
        })
        if (typeof param.onFail === 'function') {
          param.onFail({msg: JSON.stringify(error)})
        }
      })
  }
}
